
import type {Dayjs} from 'dayjs'
import dayjs from 'dayjs'

import {OrderFiltersInput} from '../../../__generated__/graphql';

export interface IOrdersFilters {
    search: string | null
    // file: string | null
    period: Dayjs[]
}

export const defaultFilter: IOrdersFilters = {
    search: null,
    // file: null,
    period: [dayjs().startOf('month'), dayjs().endOf('month')],
}

export const isChangedFilter = (filter: IOrdersFilters) => {
    if (filter.search !== defaultFilter.search) return true
    // if (filter.file !== defaultFilter.file) return true
    if (filter.period !== defaultFilter.period) return true
}

export const filtersToSearchParams = (filter: IOrdersFilters) => ({
    ...(filter.search && {search: filter.search}),
    // ...(filter.file && {file: filter.file}),
    ...(filter.period && {start: filter.period[0].format('YYYY-MM-DD'), end: filter.period[1].format('YYYY-MM-DD')}),
})

export const searchParamsToFilters = (params: URLSearchParams) => ({
    search: params.get('search') ? params.get('search') : defaultFilter.search,
    // file: params.get('file') ? params.get('file') : defaultFilter.file,
    period: params.get('start') && params.get('end') ? [dayjs(params.get('start')), dayjs(params.get('end'))] : defaultFilter.period,
}) as IOrdersFilters

export const filtersToQuery = (filter: IOrdersFilters) => ({
    ...(filter.search && {
        or: [
            {UID: {contains: filter.search}},
            {client: {firstName: {contains: filter.search}}},
            {client: {lastName: {contains: filter.search}}},
        ],

    }),
    ...(filter.period && {createdAt: {between: [filter.period[0].format(), filter.period[1].format()]}}),
}) as OrderFiltersInput

